module.exports = __webpack_public_path__ + "static/field_trip_img3@2x-ad3fda4ea9de2757ceac4b127932b09d.jpg";